
import React from 'react';
import './AllExports.css';

function AllExports({
  // PNG Export props
  showPNGModal,
  setShowPNGModal,
  processedSlides,
  selectedSlides,
  handleSelectAllSlides,
  handleToggleSlide,
  handleExportPNG,
  isExportingPNG,
}) {
  return (
    <>
      {/* PNG Export Modal */}
      {showPNGModal && (
        <div className="export-modal-overlay" onClick={() => setShowPNGModal(false)}>
          <div className="export-modal" onClick={(e) => e.stopPropagation()}>
            <div className="export-modal-header">
              <h3>Download as PNG</h3>
              <button className="modal-close-btn" onClick={() => setShowPNGModal(false)}>×</button>
            </div>
            
            <div className="export-modal-body">
              <div className="select-all-row">
                <label>
                  <input
                    type="checkbox"
                    checked={selectedSlides.size === processedSlides.length}
                    onChange={handleSelectAllSlides}
                  />
                  Select all ({processedSlides.length} slides)
                </label>
              </div>

              <div className="slides-selection-list">
                {processedSlides.map((slide, index) => (
                  <label key={index} className="slide-selection-item">
                    <input
                      type="checkbox"
                      checked={selectedSlides.has(index)}
                      onChange={() => handleToggleSlide(index)}
                    />
                    <span className="slide-label">Slide {index + 1}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="export-modal-footer">
              <button 
                className="export-cancel-btn"
                onClick={() => setShowPNGModal(false)}
              >
                Cancel
              </button>
              <button 
                className="export-download-btn"
                onClick={handleExportPNG}
                disabled={selectedSlides.size === 0 || isExportingPNG}
              >
                {isExportingPNG ? 'Downloading...' : `Download ${selectedSlides.size} slide${selectedSlides.size !== 1 ? 's' : ''}`}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AllExports;
